import { useFetchers, useNavigation } from "react-router";

function LoadingIndicator() {
  const transition = useNavigation();
  const fetchers = useFetchers();

  const isFetching = fetchers
    ? fetchers
        .map((fetcher) => ["loading", "submitting"].includes(fetcher.state))
        .filter((bool) => bool).length > 0
    : true;

  const isLoading = fetchers
    ? fetchers
        .map((fetcher) => fetcher.state === "loading")
        .filter((bool) => bool).length > 0
    : false;

  const isSubmitting = fetchers
    ? fetchers
        .map((fetcher) => fetcher.state === "submitting")
        .filter((bool) => bool).length > 0
    : false;

  return (
    <div
      role="progressbar"
      aria-hidden={!isFetching}
      aria-valuetext={isFetching ? "Loading" : undefined}
      className="fixed inset-x-0 top-0 left-0 z-50 h-1 animate-pulse"
    >
      <div
        className={`h-full bg-gradient-to-r from-jiwe-orange to-jiwe-yellow dark:from-jiwe-red dark:to-jiwe-dark-red transition-all duration-500 ease-in-out ${
          !isFetching ? "w-0 opacity-0 transition-none" : ""
        }
        ${transition.state === "submitting" || isSubmitting ? "w-4/12" : ""}
        ${transition.state === "loading" || isLoading ? "10-4/12" : ""}
        `}
      />
    </div>
  );
}

export default LoadingIndicator;
